export enum MultiFormSelectStyle {
    Default = 'sh-form-multiselect',
    Ghost = 'sh-form-multiselect--ghost',
    Title = 'sh-form-multiselect--title'
}
